import React, { useEffect, useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { InputTextarea } from "primereact/inputtextarea";
import { CustomButton } from "../CustomButton";
import { Text } from "../../components/Text";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { ReactComponent as Delete } from "../../svg/delete.svg";
import { ReactComponent as WEB } from "../../assets/WEB.svg";
import { useDispatch, useSelector } from "react-redux";
import { deleteFAQ, getFAQ, updateFAQ } from "../../reducers/aiSlice";
import * as Messag from "../../config/ToastMessage";
import { useLayout } from "../../context/LayoutContext";
import Loader from "../Loader";

const FAQ = ({ disabled }) => {
  const dispatch = useDispatch();
  const { toast } = useLayout();
  const [faqs, setFaqs] = useState([]);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [activeIndex, setActiveIndex] = useState(null);
  const [loading, setLoading] = useState(false);

  const faqList = () => {
    dispatch(getFAQ())
      .unwrap()
      .then((res) => {
        setFaqs(res?.rows);
      })
      .catch((error) => {
        console.error("Error fetching FAQ:", error);
      });
  };
  useEffect(() => {
    faqList();
  }, [dispatch]);

  const handleAddFaq = () => {
    setLoading(true);
    if (question && answer) {
      let data = {
        FAQs: {
          question: question,
          answer: answer,
        },
      };
      dispatch(updateFAQ(data))
        .unwrap()
        .then((res) => {
          let Message_Success = Messag.Add_FAQ_ToastSuccessMessage;
          toast?.current?.show({
            severity: "success",
            detail: Message_Success,
          });
          faqList();
          setLoading(false);
        })
        .catch((err) => {
          toast.current.show({ severity: "error", detail: err.message });
          setLoading(false);
        });
    } else {
    }
  };

  const handleDeleteFaq = (faq) => {
    setLoading(true);
    let data = {
      FAQs: faq,
    };
    dispatch(deleteFAQ(data))
      .unwrap()
      .then((res) => {
        let Message_Success = Messag.Add_FAQ_ToastSuccessdeleteMessage;
        toast?.current?.show({
          severity: "success",
          detail: Message_Success,
        });
        faqList();
        setLoading(false);
      })
      .catch((err) => {
        toast.current.show({ severity: "error", detail: err.message });
        setLoading(false);
      });
  };

  return (
    <div className="mt-2">
      <Loader visible={loading} />
      <div className="pt-3 mb-3">
        <span className="text-lg font-medium">
          <WEB className="mx-1 pt-1" />
          Customize the bot FAQ
        </span>
      </div>
      <Accordion
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
      >
        <AccordionTab
          header={
            <div
              className="flex"
              style={{
                justifyContent: "space-between",
                alignItems: "center",
                width: "55vw",
              }}
            >
              <div>
                <Text type={"heading"}>{"Add your FAQ"}</Text>
              </div>

              <div className="ml-auto">
                {activeIndex == 0 && (
                  <CustomButton
                    label="Add"
                    icon="pi pi-plus"
                    onClick={handleAddFaq}
                  />
                )}
              </div>
            </div>
          }
        >
          <label htmlFor="question">Question</label>
          <InputTextarea
            placeholder="Write your sample question ?"
            id="question"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            rows={1}
            style={{ width: "100%" }}
            disabled={disabled}
          />

          <label htmlFor="answer">Answer</label>
          <InputTextarea
            placeholder="Write your sample answer ."
            id="answer"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            rows={3}
            style={{ width: "100%" }}
            disabled={disabled}
          />
        </AccordionTab>
      </Accordion>

      <div
        className=""
        style={{
          minHeight: "30vh",
          overflow: "scroll",
          maxHeight: "55vh",
        }}
      >
        <Card className="px-3 mt-2">
          {faqs.length > 0 ? (
            faqs.map((faq, index) => (
              <div key={index}>
                <div className="flex">
                  <div>
                    <Text type={"heading"}>
                      Question : &nbsp;{faq.question}
                    </Text>
                    <div className="mx-1 mt-1">
                      <Text type={"sub-heading"}>
                        Answer : &nbsp; {faq.answer}
                      </Text>
                    </div>
                  </div>

                  <div className="ml-auto">
                    <CustomButton
                      varient="text"
                      icon={<Delete />}
                      onClick={() => handleDeleteFaq(faq)}
                      disabled={disabled}
                    />
                  </div>
                </div>
                <Divider />
              </div>
            ))
          ) : (
            <p>No FAQs available. Please add some!</p>
          )}
        </Card>
      </div>
    </div>
  );
};

export default FAQ;
